import ApiService from './api';
import { safeArray } from '../utils/money';

export interface PaymentLink {
  id: string;
  url: string;
  name?: string;
  amount: number;
  currency: string;
  description: string;
  active: boolean;
  expires_at?: string;
  created_at: string;
  payment_count: number;
  total_amount: number;
}

export interface PaymentLinkRequest {
  name: string; // 后端必填字段
  amount: number;
  currency: string;
  description?: string;
  expires_at?: string;
  max_uses?: number;
  metadata?: Record<string, any>;
}

export class PaymentLinkService {
  /**
   * 创建支付链接
   */
  static async createPaymentLink(data: PaymentLinkRequest): Promise<PaymentLink> {
    const response = await ApiService.post<PaymentLink>('/merchant/payments/links', data);
    return response.data;
  }

  /**
   * 获取支付链接列表
   */
  static async listPaymentLinks(
    page: number = 1,
    limit: number = 20,
    filters?: { active?: boolean }
  ): Promise<{
    data: PaymentLink[];
    meta: any;
  }> {
    const params = { page, limit, ...filters };
    const response = await ApiService.get('/merchant/payments/links', params);
    return {
      data: safeArray<PaymentLink>(response.data),
      meta: response.meta || { total: 0, per_page: 20, current_page: 1, last_page: 1 },
    };
  }

  /**
   * 获取支付链接详情
   */
  static async getPaymentLink(id: string): Promise<PaymentLink> {
    const response = await ApiService.get<PaymentLink>(`/merchant/payments/links/${id}`);
    return response.data;
  }

  /**
   * 更新支付链接
   */
  static async updatePaymentLink(
    id: string,
    data: Partial<PaymentLinkRequest>
  ): Promise<PaymentLink> {
    const response = await ApiService.put<PaymentLink>(
      `/merchant/payments/links/${id}`,
      data
    );
    return response.data;
  }

  /**
   * 删除支付链接
   */
  static async deletePaymentLink(id: string): Promise<void> {
    await ApiService.delete(`/merchant/payments/links/${id}`);
  }

  /**
   * 停用支付链接
   */
  static async deactivatePaymentLink(id: string): Promise<PaymentLink> {
    const response = await ApiService.put<PaymentLink>(
      `/merchant/payments/links/${id}`,
      { active: false }
    );
    return response.data;
  }

  /**
   * 激活支付链接
   */
  static async activatePaymentLink(id: string): Promise<PaymentLink> {
    const response = await ApiService.put<PaymentLink>(
      `/merchant/payments/links/${id}`,
      { active: true }
    );
    return response.data;
  }
}

export default PaymentLinkService;
